import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Handle404() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/investments');
  }, [navigate]);
  return null;
}
